@if (dataSource.length > 0) {
  <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
        <td mat-cell *matCellDef="let element">
          @if (column.keyColumn == 'status') {
            <div class="flex flex-col gap-1">
              <span>{{ formatStatus(displayValue(element.descricaoStatus)) }}</span>
              @if (element.statusId === 13 && element.motivoReajuste) {
                <span class="chip chip-warning" [matTooltip]="element.motivoReajuste">
                  Recusado: {{ element.motivoReajuste }}
                </span>
              }
            </div>
          } @else if (column.keyColumn == 'periodo') {
            {{ displayValue(element.dataInicio) }} {{ formatTime(element.horaInicio) }} até
            {{ displayValue(element.dataFinal) }} {{ formatTime(element.horaFinal) }}
          } @else if (column.keyColumn == 'origemDestino') {
            {{ displayValue(element.enderecoCompleto) }}
          } @else if (column.keyColumn == 'valorTotal') {
            {{ formatCurrency(element.valorTotal) }}
          } @else if (column.keyColumn == 'prazoPagamento') {
            {{ element.prazoPagamento ? element.prazoPagamento + ' dias' : '-' }}
          } @else if (column.keyColumn == 'obsFornecedor') {
            {{ displayValue(element.obsFornecedor) }}
          } @else if (column.keyColumn == 'atribuicoes') {
            <div class="flex flex-col gap-1">
              <span><b>Motorista:</b> {{ element.motorista?.nome ?? '-' }}</span>
              <span><b>Veículo:</b> {{ element.veiculo?.placa ?? '-' }}</span>
            </div>
          } @else if (column.keyColumn == 'action') {
            <div class="flex justify-center items-center gap-3">
              <mat-icon
                *ngIf="column.key.view"
                class="btn-icon-outline"
                fontIcon="visibility"
                matTooltip="Visualizar"
                (click)="viewItemEvent(element)"
              />
            </div>
          } @else {
            {{ displayValue(element[column.key]) }}
          }
        </td>
      </ng-container>
    }
    <tr mat-header-row class="style-header" *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row class="style-row" *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}
